/*
https://vitejs.dev/guide/env-and-mode.html#env-files
*/
const ENV = import.meta.env;
const parseEnv = Object.entries(ENV).reduce((acc, [key, value]) => {
  if (value === "true") {
    acc[key] = true;
    return acc;
  }
  if (value === "false") {
    acc[key] = false;
    return acc;
  }
  if (typeof value === "string") {
    acc[key] = value;
    return acc;
  }
  return acc;
}, {} as ImportMetaEnv);

export const {
  VITE_API_ENDPOINT,
  VITE_MIXPANEL_TOKEN,
  VITE_PROD_MODE,
  VITE_SENTRY_DSN,
  VITE_STAGING_BASIC_AUTH_PASSWORD,
} = parseEnv;

export enum EBuildMode {
  PRODUCTION = "production",
  UAT = "staging",
}
